import { render, staticRenderFns } from "./ListarDetalhesDadosCadastro.vue?vue&type=template&id=33759a6c&scoped=true"
import script from "./ListarDetalhesDadosCadastro.vue?vue&type=script&lang=js"
export * from "./ListarDetalhesDadosCadastro.vue?vue&type=script&lang=js"
import style0 from "./ListarDetalhesDadosCadastro.vue?vue&type=style&index=0&id=33759a6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33759a6c",
  null
  
)

export default component.exports